module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "int"
    }
  }, [_c('h1', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('span', {
    staticClass: "big"
  }, [_vm._v("<")]), _vm._v(" INTRODUCTION "), _c('span', {
    staticClass: "big"
  }, [_vm._v(">")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("I’ve been developing Cannabis-specific recipes, testing them, and cooking with Cannabis for four years, and every time I work with a new strain of Cannabis or a new ratio of CBD to THC, a new experience presents itself. This book is a culmination of my adventures with Cannabis in the kitchen. It’s an invitation to start experimenting and developing your own relationship with Cannabis. It is my hope that you fall in love, as I have, with the concept of cooking with and honoring this healing mother herb. As you will learn, if you read about the human endocannabinoid system in Appendix A ("), _c('span', {
    attrs: {
      "href": "#/OEBPS/9781454940760_epub_apa_r1#page182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 182")]), _vm._v("), no other plant has the same affinity to human health through actual physical connections in our brain and body.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Because I’m a culinary herbalist, I approach Cannabis with respect and wonder at the plant’s ability to improve human lives. I’ve capitalized the species name because this is how botanists treat the Latin names of all living organisms, so "), _c('i', [_vm._v("Cannabis")]), _vm._v(" is the only designation I use for this herb. You won’t see words such as "), _c('i', [_vm._v("marijuana")]), _vm._v(", "), _c('i', [_vm._v("dope")]), _vm._v(", "), _c('i', [_vm._v("mary jane")]), _vm._v(", "), _c('i', [_vm._v("grass")]), _vm._v(", "), _c('i', [_vm._v("bhang")]), _vm._v(", "), _c('i', [_vm._v("weed")]), _vm._v(", "), _c('i', [_vm._v("reefer")]), _vm._v(", "), _c('i', [_vm._v("pot")]), _vm._v(", "), _c('i', [_vm._v("ganja")]), _vm._v(", "), _c('i', [_vm._v("joints")]), _vm._v(", "), _c('i', [_vm._v("devil’s lettuce")]), _vm._v(", "), _c('i', [_vm._v("hash")]), _vm._v(", "), _c('i', [_vm._v("blunts")]), _vm._v(", "), _c('i', [_vm._v("dabs")]), _vm._v(", "), _c('i', [_vm._v("wax")]), _vm._v(", "), _c('i', [_vm._v("shatter")]), _vm._v(", "), _c('i', [_vm._v("kine bud")]), _vm._v(", "), _c('i', [_vm._v("dime")]), _vm._v(", "), _c('i', [_vm._v("Maui wowie")]), _vm._v(", or "), _c('i', [_vm._v("mafafa")]), _vm._v(" in this book. It was the vilification and banning of this plant that earned it a thousand code names in almost as many languages, and now, after 80 years of worldwide war on the plant, we in Canada and other jurisdictions where it is legal, can use its Latin name openly and with reverence.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("My background in cooking with healing herbs has also taught me to use whole herbs, not only in medicine, but also in food. When we isolate one component from a plant, we produce a drug that’s not food, and herbalists agree that using the whole plant makes for more powerful herbal medicine. And medicine, albeit "), _c('i', [_vm._v("delicious")]), _vm._v(" medicine, is what you will be making, whether intentionally or not, when you begin to cook with Cannabis.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("What you will see in the recipes is the addition of other healing herbs—herbs like cinnamon, turmeric, ginger, and garlic. As long as the taste is awesome, why wouldn’t we add other calming, anti-inflammatory, or pain-fighting herbs to everyday recipes? Why wouldn’t we want our food to be our medicine as the Greek physician Hippocrates (c. 460–c. 370 BCE) so wisely advised over 2,000 years ago?")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v("If you’re new to Cannabis or Cannabis edibles, you might want to start by reading Appendix A “Cannabis Basics: Understanding the Human Endocannabinoid System” because this will give you an understanding of how Cannabis affects humans. If you just want to get into the kitchen and cook, take a look at chapter 1, “Cooking with Cannabis: Kitchen Basics” because there are some key techniques that you need to master in order to have the best experience with Cannabis edibles.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However your Cannabis-in-the-kitchen adventure unfolds, I hope you learn and develop your own responsible, fun, and tasty food experimentation with Cannabis.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Be well and eat Cannabis.")]), _vm._v(" "), _c('p', {
    staticClass: "sign"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/vii-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxhead",
    attrs: {
      "id": "bxvii"
    }
  }, [_c('b', [_vm._v("RISKS OF EARLY CANNABIS USE")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("It can’t be emphasized enough: THC in Cannabis is strictly out of bounds for children, adolescents, and young adults (anyone under age 25). For this group, it has been shown to increase the risk of schizophrenia-like psychoses and may trigger acute schizophrenic psychosis; it may increase deficits in attention and motivation; and it may cause apathy and changes in personality, emotions, and cognitive functions. Taking THC in Cannabis when young can also negatively affect memory. All this to say, label and keep your Cannabis flower, infusions, tinctures, and edibles stored safely away from anyone under the age of 25.")])]), _vm._v(" "), _c('p', {
    staticClass: "image1",
    attrs: {
      "id": "ffviii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/viii-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd1794d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454940760_epub_int_r1.vue
// module id = 69
// module chunks = 0